import { useSelector } from "react-redux";

export const useInsurance = () => {
    return useSelector((state) => state.insurance);
};
